export default __webpack_public_path__ + "static/media/56_desktop.365a16e4.jpg";